import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Holiday } from "@app/core/models/holiday";

@Injectable({
    providedIn: 'root'
})
export class HolidayService {
    private readonly endpoints = {
        list: 'holiday/list',
    };
    
    constructor(private readonly http: HttpClient) {}

    list(): Observable<Holiday[]> {
        return this.http.get<Holiday[]>(this.endpoints.list);
    }
}